import React, { useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import posed from 'react-pose';

const styleIn = {
  x: 0,
  y: 0,
  transition: { duration: 700 },
  opacity: 1,
};
const styleOut = {
  y: '50%',
  opacity: 0.2,
};
const styleOutLeft = {
  x: '-150%',
};
const styleOutRight = {
  x: '150%',
};

const LeftAnimatedDiv = posed.div({
  in: { ...styleIn },
  out: { ...styleOut, ...styleOutLeft },
});
const RightAnimatedDiv = posed.div({
  in: { ...styleIn },
  out: { ...styleOut, ...styleOutRight },
});

function Animated({ direction, inView, children }) {
  let AnimatedDiv;
  if (direction === 'left') {
    AnimatedDiv = LeftAnimatedDiv;
  } else {
    AnimatedDiv = RightAnimatedDiv;
  }
  return <AnimatedDiv pose={inView ? 'in' : 'out'}>{children}</AnimatedDiv>;
}

function AnimateOnVisible({ direction = 'left', children }) {
  const [hasAnimated, setHasAnimated] = useState(false);
  const onVisibilityChange = isVisible => {
    if (isVisible) {
      setHasAnimated(true);
    }
  };
  return (
    <VisibilitySensor onChange={onVisibilityChange} partialVisibility>
      {({ isVisible }) => {
        const isContentInView = isVisible || hasAnimated;
        return (
          /* Need an intermediary container to check actual visibility, as the animated container may be off screen */
          <div>
            <Animated direction={direction} inView={isContentInView}>
              {children}
            </Animated>
          </div>
        );
      }}
    </VisibilitySensor>
  );
}

export default AnimateOnVisible;
